<template>
  <div class="operation">
    <Header />
    <Banner :src="src" />
    <!-- operation_banner -->

    <div class="company">
      <div class="title">
        <h2>职位列表</h2>
      </div>
      <ul class="incestor_ul">
        <li
          v-for="(item, index) in joblist"
          :key="index"
          class="news_items"
          @click="goDetail(index)"
        >
          <div class="left">> {{ item.bd_titlecn }}</div>
          <div class="right">查看详情</div>
        </li>
      </ul>
    </div>
    <!-- 企业文化 -->
    <Footer />
    <!-- 底部 -->
  </div>
</template>

<script>
import Footer from "../../components/Footer.vue";
import Banner from "../../components/Banner.vue";
import Header from "../../components/Header.vue";
import Axios from "axios";
const Base64 = require("js-base64");
export default {
  components: { Header, Banner, Footer },
  data() {
    return {
      src: "",
      joblist: [],
    };
  },
  mounted() {
    Axios({
      url: "/apiv2/bdoc/getlist?bdContenttype=加入我们",
      data: {},
      method: "GET",
    }).then((res) => {
      this.joblist = res.data.data.rows;
    });
     Axios({
			url: '/apiv2/sconfig/getlist',
			data: {},
			method: 'GET',
		}).then((res) => {
        for (var i = 0; i < res.data.data.rows.length; i++) {
          if (res.data.data.rows[i].sc_key.slice(0, 8) == "VALUEPIC") {
            this.src =
             res.data.data.rows[i].sc_value;
          }
        }
    })
  },
  methods: {
    goDetail(index) {
      this.$router.push({
        path: "/detail",
        query: {
          detailText: this.joblist[index].bd_atpid,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 1200px) {
  @import "../../style/base.scss";
  @import "./index.scss";
}
@media (max-width: 1199px) {
  @import "../../style/mb.scss";
  @import "./m-index.scss";
}
</style>